import lc0  from '../../assets/images/gallery/lc.webp';
import lc1  from '../../assets/images/gallery/lc1.webp';
import lc10 from '../../assets/images/gallery/lc10.webp';
import lc12 from '../../assets/images/gallery/lc12.webp';
import lc13 from '../../assets/images/gallery/lc13.webp';
import lc14 from '../../assets/images/gallery/lc14.webp';
import lc16 from '../../assets/images/gallery/lc16.webp';
import lc17 from '../../assets/images/gallery/lc17.webp';
import lc18 from '../../assets/images/gallery/lc18.webp';
import lc19 from '../../assets/images/gallery/lc19.webp';
import lc20 from '../../assets/images/gallery/lc20.webp';
import lc23 from '../../assets/images/gallery/lc23.webp';

export const galleryImagesArray = [
  {
    src: lc0,
    alt: 'Lady Cinder — neon-gothic portrait with magenta/violet aura',
    title: 'Neon-Gothic Aura',
    caption: 'Celestial edge. Velvet danger.',
  },
  {
    src: lc1,
    alt: 'Lady Cinder — dark glam portrait with electric highlights',
    title: 'Electric Glam',
    caption: 'Eyes ever watching.',
  },
  {
    src: lc10,
    alt: 'Lady Cinder — dramatic pose in high-contrast neon light',
    title: 'High-Contrast Neon',
    caption: 'Obedience under the glow.',
  },
  {
    src: lc12,
    alt: 'Lady Cinder — studio shot with occult elegance',
    title: 'Occult Elegance',
    caption: 'Divinity, sharpened.',
  },
  {
    src: lc13,
    alt: 'Lady Cinder — ritual styling with gothic accents',
    title: 'Ritual Poise',
    caption: 'Where the ritual begins.',
  },
  {
    src: lc14,
    alt: 'Lady Cinder — cinematic frame in magenta tones',
    title: 'Cinematic Magenta',
    caption: 'Flicker. Focus. Follow.',
  },
  {
    src: lc16,
    alt: 'Lady Cinder — poised portrait, violet glow',
    title: 'Violet Poise',
    caption: 'Kneel and listen.',
  },
  {
    src: lc17,
    alt: 'Lady Cinder — severe beauty with celestial hints',
    title: 'Severe & Celestial',
    caption: 'Pretty as a threat.',
  },
  {
    src: lc18,
    alt: 'Lady Cinder — hypnotic gaze, neon-soft lighting',
    title: 'Hypnotic Gaze',
    caption: 'Down. Deeper.',
  },
  {
    src: lc19,
    alt: 'Lady Cinder — graphic portrait in gothic palette',
    title: 'Graphic Gothic',
    caption: 'Ink, iron, and intent.',
  },
  {
    src: lc20,
    alt: 'Lady Cinder — moody close-up, shadow and flame',
    title: 'Shadow & Flame',
    caption: 'Fire eater. Mind keeper.',
  },
  {
    src: lc23,
    alt: 'Lady Cinder — iconic look with neon edge',
    title: 'Neon Edge',
    caption: 'Belong to Me.',
  },
];

export const smallGalleryImagesArray = [
  {
    id: 'g0',
    src: lc0,
    alt: 'Lady Cinder — neon-gothic portrait with magenta/violet aura',
    ariaLabel: 'Neon-gothic portrait glowing in magenta and violet',
  },
  {
    id: 'g1',
    src: lc1,
    alt: 'Lady Cinder — dark glam portrait with electric highlights',
    ariaLabel: 'Dark glam portrait with neon electric accents',
  },
  {
    id: 'g10',
    src: lc10,
    alt: 'Lady Cinder — dramatic pose in high-contrast neon light',
    ariaLabel: 'High-contrast neon portrait of Lady Cinder',
  },
  {
    id: 'g12',
    src: lc12,
    alt: 'Lady Cinder — studio shot with occult elegance',
    ariaLabel: 'Studio portrait with occult elegance',
  },
  {
    id: 'g14',
    src: lc14,
    alt: 'Lady Cinder — cinematic frame in magenta tones',
    ariaLabel: 'Cinematic portrait in magenta neon tones',
  },
  {
    id: 'g16',
    src: lc16,
    alt: 'Lady Cinder — poised portrait, violet glow',
    ariaLabel: 'Poised portrait bathed in violet glow',
  },
  {
    id: 'g18',
    src: lc18,
    alt: 'Lady Cinder — hypnotic gaze, neon-soft lighting',
    ariaLabel: 'Hypnotic gaze in soft neon lighting',
  },
  {
    id: 'g20',
    src: lc20,
    alt: 'Lady Cinder — moody close-up, shadow and flame',
    ariaLabel: 'Close-up portrait with shadow and flame tones',
  },
];